export { default as Home } from "./home";
export { default as Clones } from "./clones";
export { default as CloneItem } from "./clones/[clone]";
export { default as Favorites } from "./cabinet/favorites";
export { default as Inquiries } from "./inquiries";
export { default as AboutUs } from "./about-us";
export { default as UserProfile } from "./users/user-profile";
// export { default as Chat } from "./cabinet/chat";
export { default as ChatItem } from "./cabinet/chat/[id]";
export { default as MyClonesCreate } from "./cabinet/my-clones/create";
export { default as MyClonesEdit } from "./cabinet/my-clones/edit";
export { default as InquiryItem } from "./inquiries/[inquiry]";
export { default as ProfileInfo } from "./users/user-profile/info";
export { default as Cabinet } from "./cabinet";
export { default as MyInquiries } from "./cabinet/my-inquiries";
export { default as Watchlist } from "./cabinet/watchlist";
export { default as UserProfileInfo } from "./users/user-profile/info";
export { default as UserProfileClones } from "./users/user-profile/clones";
export { default as UserProfileInquiries } from "./users/user-profile/inquiries";
export { default as MyClones } from "./cabinet/my-clones";
export { default as CreateInquiry } from "./cabinet/my-inquiries/create";
export { default as EditInquiry } from "./cabinet/my-inquiries/edit";
export { default as Deals } from "./cabinet/deals";
export { default as DealItem } from "./cabinet/deals/[deal]";
export { default as Registration } from "./registration";
export { default as CookiePolicy } from "./cookie-policy/index";
export { default as PrivacyPolicy } from "./privacy-policy";
export { default as Opportunities } from "./opportunities";
export { default as Settings } from "./cabinet/settings";
export { default as Blog } from "./blog";
export { default as BlogItem } from "./blog/[blog-item]";
export { default as TermsOfUse } from "./terms-of-use";
export { default as ContactUs } from "./contact-us";
export { default as NotFound } from "./not-found";
export { default as ErrorPage } from "./error";
